<template>
  <analytics-sub-page
    title="Budget Analytics"
    icon="wallet"
    css-class="analytics-budget"
    default-label="Budget"
    :section-specs="sectionSpecs"
  >
    <track-metrics ref="trackRef" />
    <budget-metrics ref="budgetRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import BudgetMetrics from '@/pages/analyticsApp/components/BudgetMetrics.vue';
import TrackMetrics from '@/pages/analyticsApp/components/TrackMetrics.vue';

const trackRef = ref(null);
const budgetRef = ref(null);

const sectionSpecs = [
  { key: 'track', label: 'Track', ref: trackRef },
  { key: 'budget', label: 'Budget', ref: budgetRef },
];
</script>
